import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button, FormControl } from "react-bootstrap";

import ModalWrapper from "./ModalWrapper";

export default class TagEditModal extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = { tag: props.tag };
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleTagTextChange = this.handleTagTextChange.bind(this);
	}

	handleSave()
	{
		this.props.onSave(this.state.tag);
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleTagTextChange(event)
	{
		const tag = this.state.tag;
		tag.text = event.target.value;

		this.setState({ tag });
	}

	render()
	{
		const tag = this.state.tag;

		const footerElements = [
			<Button key={0} onClick={this.handleSave}>Save</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Tag Edit"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<Row>
					<Col xs={6}>
						<label>Text:</label>
					</Col>
					<Col xs={6}>
						<FormControl
							type="text"
							placeholder="Text"
							className="mousetrap-mod"
							value={tag.text || ""}
							onChange={this.handleTagTextChange}
							autoFocus={true}
						/>
					</Col>
				</Row>
			</ModalWrapper>
		);
	}
}

TagEditModal.propTypes = {
	onClose: PropTypes.func,
	onSave: PropTypes.func,
	tag: PropTypes.shape({
		id: PropTypes.number,
		text: PropTypes.string
	})
};



// WEBPACK FOOTER //
// ./Components/components/TagEditModal.jsx